<tiime-dialog [isLoading]="isLoading()" (cancel)="cancel()">
  <div class="dialog-container">
    <div class="dialog-container-header">
      <span>{{ data.type === SendContractType.signature ? 'Envoyer' : 'Relancer' }} le contrat</span>
    </div>
    <div mat-dialog-content class="dialog-content">
      <tiime-card class="contract-attachments-card">
        <tiime-card-header>
          <tiime-twocolors-icon icon="ic_twocolors_documents" size="24" tiimeCardHeaderIcon></tiime-twocolors-icon>
          <span tiimeCardHeaderTitle>Pièces jointes du contrat</span>
          <div tiimeCardHeaderActions>
            <mat-icon
              class="action-infos-icon"
              fontSet="fontastic"
              fontIcon="icon-ic-info"
              tiimeTooltip="Les pièces jointes sélectionnées seront disponibles dans l’interface de signature numérique du client."
            />
          </div>
        </tiime-card-header>
        <app-multiple-attachments-selector
          [attachments]="sendContractForm.contractAttachments"
          [contractFileTypes]="contractFileTypes$ | async"
        />
      </tiime-card>
      <tiime-card>
        <tiime-card-header [class.warn]="sendContractForm.errorMessage">
          <tiime-twocolors-icon icon="ic_twocolors_mail" size="24" tiimeCardHeaderIcon></tiime-twocolors-icon>
          <span tiimeCardHeaderTitle>Envoyer par mail</span>
          <div tiimeCardHeaderActions>
            <mat-slide-toggle color="primary" [formControl]="sendContractForm.sendByMail"></mat-slide-toggle>
          </div>
        </tiime-card-header>
        @if (sendContractForm.errorMessage) {
          <span class="error-message">
            {{ sendContractForm.errorMessage.message }}
          </span>
        }
        @if (sendContractForm.sendByMail.value) {
          <tiime-alert accent>Le lien de signature sera automatiquement inséré dans l'email.</tiime-alert>
          <tiime-input-container label="Modèle de mail" small contentId="mail-template-select">
            <tiime-select
              id="mail-template-select"
              [formControl]="sendContractForm.mailTemplateId"
              placeholder="Sélectionner un modèle d’email"
            >
              <div tiimeSelectOptions>
                @for (template of contractMailTemplates(); track template.id) {
                  <mat-option [value]="template.id">
                    {{ template.name }}
                  </mat-option>
                }
              </div>
            </tiime-select>
          </tiime-input-container>

          <app-email-form
            [form]="sendContractForm.email"
            [displayTo]="displayTo()"
            [displayCc]="displayCc()"
            [displayCci]="displayCci()"
            [displayAddAttachment]="true"
            [messageMinRows]="7"
            [canSelectAttachments]="true"
            [fromEmails]="fromEmails()"
            [contractFileTypes]="contractFileTypes$ | async"
            (loading)="isLoading.set($event)"
          />
        }
      </tiime-card>
      <tiime-card>
        <tiime-card-header [class.warn]="sendContractForm.errorMessage">
          <tiime-twocolors-icon icon="ic_twocolors_smartphone" size="24" tiimeCardHeaderIcon></tiime-twocolors-icon>
          <span tiimeCardHeaderTitle>Envoyer par SMS</span>
          <div tiimeCardHeaderActions>
            <mat-slide-toggle color="primary" [formControl]="sendContractForm.sendBySms"></mat-slide-toggle>
          </div>
        </tiime-card-header>
        @if (sendContractForm.errorMessage) {
          <span class="error-message">
            {{ sendContractForm.errorMessage.message }}
          </span>
        }
        @if (sendContractForm.sendBySms.value) {
          <tiime-alert accent>Le lien de signature sera automatiquement inséré dans le sms.</tiime-alert>
          <app-sms-form [form]="sendContractForm.sms" />
        }
      </tiime-card>
    </div>
    <div class="actions">
      <button tiime-button color="accent" strocked (click)="cancel()" data-cy="contract-dialog-cancel-btn">
        Annuler
      </button>
      <button
        tiime-button
        color="accent"
        raised
        [disabled]="sendContractForm.disabled"
        (click)="sendContract()"
        data-cy="contract-dialog-save-btn"
      >
        Envoyer
      </button>
    </div>
  </div>
</tiime-dialog>
